export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1900;

  return Array.from({ length: currentYear - startYear + 1 }, (_, index) => ({
    text: (currentYear - index).toString(),
    value: currentYear - index,
  }));
};

export const getNegotiationStageOptions = () => [
  {
    text: 'New lead',
    value: 'new_lead',
  },
  {
    text: 'Initial offer made',
    value: 'initial_offer_made',
  },
  {
    text: 'Negotiation in progress',
    value: 'negotiation_in_progress',
  },
  {
    text: 'Verbal agreement reached',
    value: 'verbal_agreement_reached',
  },
  {
    text: 'Contract sent for review',
    value: 'contract_sent_for_review',
  },
];
